<script setup>
import {
  DrawerContent as DrawerContentPrimitive,
  DrawerPortal,
} from "vaul-vue";
import { cn } from "@/shared/lib/utils";
import DrawerOverlay from "./DrawerOverlay.vue";

const props = defineProps({
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <DrawerPortal>
    <DrawerOverlay />
    <DrawerContentPrimitive
      data-slot="drawer-content"
      :class="
        cn(
          'group/drawer-content bg-background fixed z-50 flex h-auto flex-col outline-none',
          'data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=bottom]:mt-24 data-[vaul-drawer-direction=bottom]:max-h-[96dvh] data-[vaul-drawer-direction=bottom]:rounded-t-lg',
          'data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=right]:right-0',
          'data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=left]:left-0',
          'data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=top]:mb-24 data-[vaul-drawer-direction=top]:max-h-[96dvh] data-[vaul-drawer-direction=top]:rounded-b-lg',
          'p-6 select-text',
          props.class
        )
      "
    >
      <div
        class="bg-border mx-auto mt-4 hidden h-1.5 w-12 shrink-0 rounded-full group-data-[vaul-drawer-direction=bottom]/drawer-content:block"
      />
      <slot />
    </DrawerContentPrimitive>
  </DrawerPortal>
</template>
